export default "__VITE_ASSET__p3olAxB4__"